@if (reviews().length) {
  <span class="ai-chip" role="status" [attr.title]="details()" [attr.aria-label]="label() + '. ' + details()">
    <mat-icon aria-hidden="true">auto_awesome</mat-icon>
    {{ label() }}
  </span>
}
